//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'JobManageItem',
  props: {
    item: { type: Object, default: () => {} },
    details: { type: Boolean, default: false },
  },
  methods: {
    gotoSeeker() {
      if (!this.item.jobPositionId) return;
      this.$router.push(
        `/Owner/Manage?tab=jobsManagement&subTab=jobsManagement&jobPositionId=${this.item.jobPositionId}`,
      );
    },
    gotoEdit() {
      if (!this.item.jobPositionId) return;
      this.$router.push(
        `/Owner/Manage?tab=jobsManagement&subTab=jobsManagement&jobPositionId=${this.item.jobPositionId}&isEdit=true`,
      );
    },
    deleteJob() {
      this.$confirm(`是否刪除 ${this.item.title}？`, '提示', {
        type: 'warning',
      }).then(() => {
        this.$api('deleteOwnerJob', {
          jobPositionId: this.item.jobPositionId,
        }).then(() => {
          this.$message.success('刪除職缺成功!');
          this.$emit('update');
        });
      });
    },
  },
};
